// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Av0Q","actionsCol":"EnrolledClinics_actionsCol__28hKa"};